<template>
  <div class="home">
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
            Parte 
            <v-btn icon @click="deleteDocument">
                <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
        </v-card-title>
        <v-alert
            v-if="alert"
            dense
            type="info"
            >
            <span class="alertContent">{{alertContent}}</span>
        </v-alert>
        <v-layout row wrap >
            <v-flex xs7 offset-xs1>
                <v-autocomplete
                    v-model="user"
                    :items="users"
                    item-text="Name"
                    item-value="User"
                    label="Acompañante/s"
                    hint="Seleccione acompañante/s (opcional)"
                    persistent-hint
                    chips
                    multiple
                    dense
                ></v-autocomplete>
                <!--v-select
                v-model="user"
                :items="users"
                item-text="Name"
                item-value="User"
                label="Acompañante/s"
                multiple
                chips
                hint="Seleccione acompañante/s (opcional)"
                persistent-hint
                ></v-select-->
            </v-flex>
            <v-flex xs2 offset-xs1 mt-3>
                <v-layout row wrap >
                    <v-flex xs12>
                        Titular
                        <br>
                        <v-checkbox
                        v-model="driver"
                        disabled
                        class="ma-0 pa-0 ml-6"
                        ></v-checkbox>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex v-if="$store.state.relations.length > 0" xs10 offset-xs1>
                <v-select
                v-model="relation"
                :items="relations"
                :item-text="albaranCaption"
                item-value="Ruta"
                label="Albarán Relacionado"
                chips
                hint="Seleccione albarán relacionado"
                persistent-hint
                dense
                ></v-select>
            </v-flex>
            <v-flex xs7 offset-xs1>
                <v-text-field :error="errorJobField" :error-messages="errorJobFieldMessage" v-model="proyecto" @click="openJobDialog" type="text" label="Proyecto" readonly dense></v-text-field>
            </v-flex>
            <v-flex xs2 offset-xs1 >
                <v-layout row wrap >
                    <v-flex xs12>
                        Revisión
                        <br>
                        <v-checkbox
                        v-model="revision"
                        class="ma-0 pa-0 ml-6"
                        ></v-checkbox>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 sm10 offset-sm1 mb-3>
                <TimeTable/>
            </v-flex>  
            <!--v-flex xs10 offset-xs1 mb-3>
                <Uploader/>
            </v-flex-->
        </v-layout>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <v-footer absolute padless>
            <v-flex xs10 offset-xs1 mb-3 v-if="showInvoiceable">
              <v-btn large block color="primary" dark @click="openTaskTimeDialog">Facturación</v-btn>
            </v-flex>
            <v-flex xs10 offset-xs1 mb-3>
              <v-btn large block color="primary" dark @click="openTaskTimeDialogPersonal">Parte de trabajo</v-btn>
            </v-flex>                           
            <br>          
            <v-flex xs4 offset-xs1 >
              <v-btn block color="error" dark @click="close">Cancelar</v-btn>
            </v-flex>
            <v-flex xs4 offset-xs2>
              <v-btn block color="success" dark @click="openSignatureDialog">Enviar</v-btn>
            </v-flex>
        </v-footer>
    </div>
</template>

<script>
// @ is an alias to /src
import TimeTable from '@/components/TimeTable.vue'
//import Uploader from '@/components/ImageUploader.vue'

export default {
  name: 'parte',
  components: {
    TimeTable,
    //Uploader
  },
  data () {
      return { 
        errorJobField: false,
        errorJobFieldMessage: '',
        showInvoiceable: true
      }
    },
    methods:{
        close(){            
            this.deleteDocument();
            if (this.hasHistory())
                this.$router.go(-1);
            else
                this.$router.push('Agenda');
        },
        closeOK(){                        
            if (this.hasHistory())
                this.$router.go(-1);
            else
                this.$router.push('Agenda');
        },    
        albaranCaption(item){
            if ((item.Proyecto != null) && (item.Proyecto != 'null')){
                return item.Ruta + ' - ' + item.Proyecto;
            } else {
                return item.Ruta;
            }
        },
        openJobDialog(){
            if (this.lineas.length > 0){
                this.errorJobField = true;
                this.errorJobFieldMessage = 'No se puede cambiar el proyecto con lineas ya imputadas'
                var thisaux = this;
                setTimeout(function(){
                    thisaux.errorJobField = false;
                    thisaux.errorJobFieldMessage = ''
                },3000);
            } else {
                this.dialogProyecto = true;
            }
        },
        openTaskTimeDialog(){
          if (this.proyecto == ''){
            this.errorJobField = true;
            this.errorJobFieldMessage = 'Rellene primero el proyecto'
            var thisaux = this;
            setTimeout(function(){
              thisaux.errorJobField = false;
              thisaux.errorJobFieldMessage = ''
            },3000);
          } else {
            //this.dialogInputHoras = true;
            this.$router.push('Horas'); 
          }
        },
        openTaskTimeDialogPersonal(){
          if (this.proyecto == ''){
            this.errorJobField = true;
            this.errorJobFieldMessage = 'Rellene primero el proyecto'
            var thisaux = this;
            setTimeout(function(){
              thisaux.errorJobField = false;
              thisaux.errorJobFieldMessage = ''
            },3000);
          } else {
            //this.dialogInputHorasPersonal = true;
            this.$router.push('HorasPersonal'); 
          }
        },
        openSignatureDialog(){
          //this.dialog = false;
          //this.dialogSignature = true;
          this.$router.push('Resumen');
        },
        deleteDocument(){
          this.$store.commit('resetDataAfterSuccessfulCreation');
        }
    },
    mounted(){
        this.getUsers();
        this.getDocumentRelation();
        if (this.relation != ''){
            this.showInvoiceable = false;
        } else {
            this.showInvoiceable = true;
        }
    },
    watch:{    
        relation: function (val){ 
            if (val){
                console.log(val);
                this.showInvoiceable = false;
                this.readRelatedDocument(val);
            } else {
                this.showInvoiceable = false;
            }
        }
    },
    computed:{
        dialog: {
            get(){
                return this.$store.state.dialogParte;
            },
            set(value){
                this.$store.state.dialogParte = value;
            }
        },
        dialogProyecto: {
            get(){
                return this.$store.state.dialogProyecto;
            },
            set(value){
                this.$store.state.dialogProyecto = value;
            }
        },
        dialogInputHoras: {
            get(){
                return this.$store.state.dialogInputHoras;
            },
            set(value){
                this.$store.state.dialogInputHoras = value;
            }
        },
        dialogInputHorasPersonal: {
            get(){
                return this.$store.state.dialogInputHorasPersonal;
            },
            set(value){
                this.$store.state.dialogInputHorasPersonal = value;
            }
        },
        dialogSignature: {
            get(){
                return this.$store.state.dialogSignature;
            },
            set(value){
                this.$store.state.dialogSignature = value;
            }
        },
        proyectos:{
            get(){
                return this.$store.state.jobs;
            }
        },
        tareas:{
            get(){
                return this.$store.state.jobTasks;
            }
        },
        proyecto:{
            get(){
                //return this.$store.state.proyecto;
                var jobno = this.$store.state.proyecto;
                var fullname = jobno;
                if (jobno != ''){
                  var res = this.proyectos.find(job =>{
                    return job.no == jobno;
                  });
                  if (res){
                    fullname = jobno + ' - ' + res.description;
                  }
                }
                return fullname;
            }/*,
            set(value){
                this.$store.state.proyecto = value;
            }*/
        },
        proyectoFullName:{
            get(){
                var jobno = this.$store.state.proyecto;
                var fullname = '';
                if (jobno != ''){
                  var res = this.$store.state.proyectos.find(job =>{
                    return job.no == jobno;
                  });
                  console.log(res);
                }
                return fullname;
            }
        },
        tarea:{
            get(){
                return this.$store.state.tarea;
            }/*,
            set(value){
                this.$store.state.tarea = value;
            }*/
        },
        users:{
            get(){
                return this.$store.state.users;
            }/*,
            set(value){
                this.$store.state.tarea = value;
            }*/
        },
        user:{
            get(){
                return this.$store.state.user;
            },
            set(value){
                this.$store.commit('saveUser', value);
            }
        },
        relations:{
            get(){
                return this.$store.state.relations;
            }/*,
            set(value){
                this.$store.state.tarea = value;
            }*/
        },
        relation:{
            get(){
                return this.$store.state.relation;
            },
            set(value){
                this.$store.commit('saveRelation', value);
            }
        },
        images:{
            get(){
                return this.$store.state.images;
            },
            set(value){
                this.$store.state.images = value;
            }
        },
        lineas:{
            get(){
                return this.$store.state.lineasParte;
            }            
        },
        alert:{
            get(){
                return this.$store.state.globalAlert;
            },
            set(value){
                this.$store.commit('saveGlobalAlert', value);
            }
        },
        alertContent:{
            get(){
                return this.$store.state.globalAlertContent;
            },
            set(value){
                this.$store.commit('saveGlobalAlertContent', value);
            }
        },
        driver:{
            get(){
                return this.$store.state.driver;
            },
            set(value){
                this.$store.commit('saveDriver', value);
            }
        },
        revision:{
            get(){
                return this.$store.state.revision;
            },
            set(value){
                this.$store.commit('saveRevision', value);
            }
        }
    }
}
</script>
<style scoped>
.home{
    height: 100%;
}
.fc{
    height: 100%;
}
.full{
    height: 100%;
}
.alertContent{
    font-size: small;
}
</style>
